import { OrderType } from 'types';

export enum TaskType {
	delivery = 'delivery',
	claiming = 'claiming',
	replacement = 'replacement',
}

export interface Task {
	id: number;
	orderId: number;
	nextOrderId: number | null;
	orderType: OrderType;
	type: TaskType;
	date: Date;
	assignedTo: number | null;
	takenAt: Date | null;
	doneAt: Date | null;
	createdAt: Date;
	createdBy: number | null;
}
